<template>
  <div v-bind:class="amplifyUI.formSection">
    <div v-bind:class="amplifyUI.sectionHeader">{{this.options.header}}</div>
    <v-form ref="form" v-bind:class="amplifyUI.sectionBody" class="su-fields">
      <p class="welcome-text">
        If you have {{ mersBranded ? "a MERS" : "an Alerus" }} account, 
        but have not accessed {{ mersBranded ? "myMERS" : "My Alerus" }}, 
        then provide the following information to get started.
      </p>
      <v-container fluid class="pa-0 mt-3">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">First Name</div>
            <v-text-field
              autocomplete="given-name"
              aria-label="first name"
              outline
              v-model="extraInfo.firstName"
              :rules="[rules.required]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">Last Name</div>
            <v-text-field
              autocomplete="family-name"
              outline
              aria-label="last name"
              v-model="extraInfo.lastName"
              :rules="[rules.required]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="mersBranded">
          <!-- <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">MERS Account Verification</div>
            <v-select
              v-model="extraInfo.product"
              :items="mersItems"
              item-text="name"
              item-value="value"
              :hint="bankingTips"
              persistent-hint
              :rules="[rules.required]"
              outline
              :placeholder="extraInfo.product ? undefined : 'Please select one'"
              @change="getProduct"
              class="Input__input___2Sh1s"
            ></v-select>
          </v-flex> -->
          <v-flex xs12 sm3>
            <div class="Input__inputLabel___nQolz">Date of Birth</div>
            <v-text-field
              outline
              autocomplete="bday"
              v-model="extraInfo.dob"
              aria-label="date of birth"
              placeholder="mm/dd/year"
              mask="##/##/####"
              :rules="[rules.required, rules.dob]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <div
              class="Input__inputLabel___nQolz"
            >{{ "Social Security Number" }}</div>
            <v-text-field
              outline
              v-model="extraInfo.ssn"
              aria-label="social security number"
              placeholder="Social Security Number"
              mask="###-##-####"
              :rules="[rules.required]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">{{ productLabel }}</div>
            <v-text-field
              outline
              v-model="extraInfo.accNum"
              :mask="productMask"
              :placeholder="productLabel"
              :rules="[rules.required]"
              :disabled="extraInfo.product ? false : true"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">Alerus Account Verification</div>
            <v-select
              v-model="extraInfo.product"
              :items="bankingItems"
              item-text="name"
              item-value="value"
              :hint="bankingTips"
              persistent-hint
              :rules="[rules.required]"
              outline
              :placeholder="extraInfo.product ? undefined : 'Please select one'"
              @change="getProduct"
              class="Input__input___2Sh1s"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="Input__inputLabel___nQolz">{{ productLabel }}</div>
            <v-text-field
              outline
              v-model="extraInfo.accNum"
              :mask="productMask"
              :placeholder="productLabel"
              :rules="[rules.required]"
              :disabled="extraInfo.product ? false : true"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm3 v-if="!mersBranded">
            <div
              class="Input__inputLabel___nQolz"
            >{{ "Social Security Number" }}</div>
            <v-text-field
              outline
              v-model="extraInfo.ssn"
              :placeholder="mersBranded ? 'Social Security Number' : '_ _ _ - _ _ - _ _ _ _'"
              mask="###-##-####"
              :rules="[rules.required]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 v-if="!mersBranded">
            <div class="Input__inputLabel___nQolz">Date of Birth</div>
            <v-text-field
              outline
              autocomplete="bday"
              v-model="extraInfo.dob"
              placeholder="mm/dd/year"
              mask="##/##/####"
              :rules="[rules.required, rules.dob]"
              class="Input__input___2Sh1s"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="phone-container">
            <div class="Input__inputLabel___nQolz">Phone Number</div>
            <v-layout class="full-phone">
              <v-flex xs4>
                <v-select
                  class="country-list"
                  outline
                  hide-details
                  v-model="country"
                  :items="countries"
                  item-text="label"
                  item-value="value"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-text-field
                  hide-details
                  v-model="phone"
                  type="text"
                  autocomplete="tel"
                  name="phone"
                  :rules="[rules.required, rules.phone]"
                  outline
                  placeholder="Phone Number"
                  :mask="phoneMask"
                  class="Input__input___2Sh1s"
                />
              </v-flex>
            </v-layout>
            <div class="v-text-field__details" v-if="phoneRequirements">
              <div class="v-messages theme--light">
                <div class="v-messages__wrapper">
                  <div
                    class="v-messages__message"
                    style
                  >This phone number will be used to verify your identity at login. Please use a mobile phone or a direct line.</div>
                </div>
              </div>
            </div>
            <div class="v-text-field__details" v-else>
              <div class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">{{ phoneError }}</div>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 sm6 v-if="mersBranded">
            <div class="Input__inputLabel___nQolz">Personal Email</div>
            <v-text-field
              outline
              persistent-hint
              hint="This email will be used for password resets and outreach purposes."
              type="string"
              v-model="options.signUpFields[1].value"
              placeholder="Personal Email"
              name="Personal Email"
              :rules="[rules.required, rules.email]"
              class="Input__input___2Sh1s"
            />
          </v-flex>
        </v-layout>
      </v-container>
      <h4 v-if="!mersBranded">Please create a new username and password.</h4>
      <v-container fluid class="pa-0 mt-4">
        <v-layout row wrap class="reg-fields">
          <v-flex
            xs12
            sm6
            v-for="signUpField in orderBy(this.options.signUpFields, 'displayOrder')"
            :signUpField="signUpField"
            v-bind:key="signUpField.key"
          >
            <div v-if="!mersBranded || signUpField.key !== 'email'" class="Input__inputLabel___nQolz">{{ signUpField.label }}</div>
            <v-text-field
              outline
              class="Input__input___2Sh1s"
              v-if="signUpField.key === 'username'"
              :type="signUpField.type"
              v-model="signUpField.value"
              aria-label="username"
              :name="signUpField.label"
              :rules="[rules.required, rules.username]"
              persistent-hint
              hint="Username can only contain letters, numbers, @, period and underscore characters"
            />
            <v-text-field
              outline
              v-if="signUpField.key === 'email' && !mersBranded"
              :persistent-hint="mersBranded"
              :hint="mersBranded ? 'This email will be used for password resets and outreach purposes.' : ''"
              :type="signUpField.type"
              aria-label="email"
              v-model="signUpField.value"
              :name="signUpField.label"
              :rules="[rules.required, rules.email]"
              class="Input__input___2Sh1s"
            />
            <v-text-field
              outline
              v-else-if="signUpField.key === 'password'"
              persistent-hint
              hint="At least 8 characters, 1 number, 1 lowercase and 1 uppercase letter"
              :type="signUpField.type"
              v-model="signUpField.value"
              autocomplete="new-password"
              aria-label="password"
              :name="signUpField.label"
              :rules="[rules.required, rules.min, rules.upper, rules.lower, rules.number]"
              class="Input__input___2Sh1s"
            />
            <v-text-field
              outline
              v-else-if="signUpField.key === 'password2'"
              :type="signUpField.type"
              aria-label="password 2"
              v-model="signUpField.value"
              :name="signUpField.label"
              :rules="[rules.required, rules.match]"
              class="Input__input___2Sh1s"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div v-bind:class="sectionFooter">
      <span v-bind:class="sectionFooterPrimary">
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="preSignUp"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button dark-btn"
        >{{$Amplify.I18n.get(mersBranded ? 'Create myMERS Account' : 'Create Account')}}</v-btn>
      </span>
      <span
        v-bind:class="amplifyUI.sectionFooterSecondaryContent"
        v-if="mersBranded"
      >
        <p>OR</p>
        <div class="mers-text">Already have an account?</div>
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="signIn"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Log In')}}</v-btn>
      </span>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" scrollable width="600px" persistent>
        <v-card>
          <v-card-text class="pa-0">
            <privacy />
          </v-card-text>
          <v-card-actions>
            <v-btn color="#0C2B4A" @click="printMe">Print</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#0C2B4A" @click="getAnswer(false)">Decline</v-btn>
            <v-btn color="#0C2B4A" @click="getAnswer(true)">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="signUpSuccess" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline">Sign Up Complete</v-card-title>
          <v-card-text>
            Sign Up complete. Please proceed to Log In.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-bind:class="amplifyUI.button"
              v-on:click="signIn"
              dark
              depressed
              :color="appButtonColor"
              large
              class="load-button"
            >{{$Amplify.I18n.get('Log In')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import Vue2Filters from "vue2-filters";
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import countries from "aws-amplify-vue/src/assets/countries";
import Privacy from "@/components/Privacy.vue";
import { mapState } from "vuex";
import VueHtmlToPaper from "@/plugins/print";
import axios from "axios";
import parser from "ua-parser-js"

Vue.use(Vue2Filters);

export default {
  name: "SignUp",
  props: ["signUpConfig"],
  mixins: [VueHtmlToPaper],
  components: {
    Privacy
  },
  data() {
    return {
      userIp: "",
      userAgent: "",
      browserDetails: "",
      country: "1",
      dialog: false,
      signUpSuccess: false,
      phone: "",
      bankingItems: [
        {
          name: "Alerus Health Benefits Debit Card Number",
          value: "healthDebit"
        },
        { name: "Alerus Bank Account Number", value: "banking" },
        { name: "Alerus Bank Debit Card Number", value: "card" },
        {
          name: "Alerus Mortgage Account Number",
          value: "mortgage"
        },
        {
          name: "Hire Date (Retirement & Benefits Participants Only)",
          value: "retirement"
        },
        {
          name: "Alerus Retirement Plan Number",
          value: "retirementByPlan"
        },
        {
          name: "Alerus Wealth Management Account Number",
          value: "wealth"
        }
      ],
      mersItems: [
        {
          name: "MERS Hire Date",
          value: "retirement"
        }
        // {
        //   name: "MERS Plan Number",
        //   value: "retirementByPlan"
        // }
      ],
      // bankingItems: [{ name: "Retirement and Benefits", value: "retirement" }],
      defaultInfo: {
        name: "Retirement and Benefits",
        value: "retirement"
      },
      phoneError: "",
      extraInfo: {
        dob: "",
        ssn: "",
        accNum: "",
        firstName: "",
        lastName: "",
        product: "",
        hireMonth: "",
        hireYear: ""
      },
      phoneRequirements: true,
      // productLabelVal: "Product",
      productLabelVal: "",
      // productLabelVal: "Retirement and Benefits",
      // productLabel: "Product Number",
      // productLabel: "Hire Month and Year (MM/YYYY)",
      productLabel: "Please Select Verification",
      // productMask: "",
      productMask: "##/####",
      terms: false,
      userResponse: false,
      countryCode: "1",
      countries,
      amplifyUI: AmplifyUI,
      error: "",
      buttonLoad: false,
      logger: {},
      rules: {
        required: v => !!v || "Required",
        username: v =>
          !/[^A-Za-z0-9@._]+/.test(v) || "Username contains illegal characters",
        min: v => String(v).length >= 8 || "Min 8 characters",
        upper: v => /[A-Z]/.test(v) || "Must include uppercase letter",
        lower: v => /[a-z]/.test(v) || "Must include lowercase letter",
        number: v => /[0-9]/.test(v) || "Must include number",
        email: v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "Invalid email address",
        phone: v => v.length >= 5 || v.length === 0 || "Phone is invalid",
        dob: v =>
          String(v).length == 8 ||
          "Please enter a valid birth date with format MM/DD/YYYY",
        match: v =>
          this.options.signUpFields[2].value ===
            this.options.signUpFields[6].value || "Passwords don't match"
      }
    };
  },
  created() {
    if (Object.entries(this.$route.query).length) {
      if (this.$route.query.hasOwnProperty("account")) {
        this.extraInfo.product = this.$route.query.account;
        this.productLabel = "Account Number";
        this.productMask = "###############";
      }
    }
    if (this.mersBranded) {
      this.extraInfo.product = "retirement";
      this.productLabel = "Hire Month and Year (MM/YYYY)";
      this.productMask = "##/####";
    }
    // Get User Ip Address
    this.getIp()
  },
  computed: {
    ...mapState("user", [
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle",
      "step"
    ]),
    sectionFooter() {
      if (this.mersBranded) {
        return `${AmplifyUI.sectionFooter} mers-auth`
      }
      else {
        return AmplifyUI.sectionFooter
      }
    },
    sectionFooterPrimary() {
      if (this.mersBranded) {
        return `${AmplifyUI.sectionFooterPrimaryContent} mb-0`
      }
      else {
        return AmplifyUI.sectionFooterPrimaryContent
      }
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    bankingTips() {
      if (this.extraInfo.product === `retirement`)
        return `If you do not know your hire date, please reach out to your employer's Human Resources department.`;
      else if (this.extraInfo.product === `retirementByPlan`)
        return `If you do not know your retirement plan number, please reach out to your employer's Human Resources department.`;
      else if (this.extraInfo.product === `card`)
        return `If you have an HSA or FSA debit card, please select 'Retirement and Benefits' from the dropdown and enter your hire date.`;
      else return "";
    },
    phoneMask() {
      if (this.country === "1") {
        return "(###) ###-####";
      } else return "##############";
    },
    newUserAtts() {
      return Object.entries(this.extraInfo).map(([key, value]) => {
        return {
          Name: key,
          Value: value
        };
      });
    },
    headerConfig() {
      if (this.retirementBranded) {
        return "Sign up for Retirement Account Access";
      } else if (this.mersBranded) {
        return "Create myMERS Account";
      } else {
        return "Set up online access to My Alerus";
      }
    },
    options() {
      const defaults = {
        // header: this.$Amplify.I18n.get("Sign Up Account"),
        header: this.headerConfig,
        signUpFields: [
          {
            label: this.$Amplify.I18n.get("Username"),
            key: "username",
            required: true,
            type: "string",
            displayOrder: 1
          },
          {
            label: this.$Amplify.I18n.get("Personal Email"),
            key: "email",
            required: true,
            type: "string",
            displayOrder: 2
          },
          {
            label: this.$Amplify.I18n.get("Password"),
            key: "password",
            required: true,
            type: "password",
            displayOrder: 3
          },
          {
            label: this.$Amplify.I18n.get("Phone Number"),
            key: "phone_number",
            required: true,
            displayOrder: 5
          },
          {
            label: "Birthdate",
            key: "custom:dateofbirth",
            type: "string",
            displayOrder: 6,
            required: true
          },
          {
            label: "Hide Birthday",
            key: "birthdate",
            required: true,
            type: "string",
            displayOrder: 7,
            value: "0000000000"
          },
          {
            label: "Confirm Password",
            key: "password2",
            required: true,
            type: "password",
            displayOrder: 4
          }
          // {
          //   label: "Terms and Conditions",
          //   key: "custom:agreedterms",
          //   required: false,
          //   type: "string",
          //   displayOrder: 8,
          //   value: new Date().toISOString()
          // }
        ]
      };

      // sets value in country code dropdown if defaultCountryCode value is present in props
      if (this.signUpConfig && this.signUpConfig.defaultCountryCode) {
        this.country = this.countries.find(
          c => c.value === this.signUpConfig.defaultCountryCode
        ).label;
      }

      if (
        this.signUpConfig &&
        this.signUpConfig.hiddenDefaults &&
        this.signUpConfig.hiddenDefaults.length > 0
      ) {
        defaults.signUpFields = defaults.signUpFields.filter(d => {
          return !this.signUpConfig.hiddenDefaults.includes(d.key);
        });
      }

      // begin looping through signUpFields
      if (
        this.signUpConfig &&
        this.signUpConfig.signUpFields &&
        this.signUpConfig.signUpFields.length > 0
      ) {
        // if hideDefaults is not present on props...
        if (!this.signUpConfig.hideDefaults) {
          // ...add default fields to signUpField array unless user has passed in custom field with matching key
          defaults.signUpFields.forEach((f, i) => {
            const matchKey = this.signUpConfig.signUpFields.findIndex(d => {
              return d.key === f.key;
            });
            if (matchKey === -1) {
              this.signUpConfig.signUpFields.push(f);
            }
          });
        }
        /* 
          sort fields based on following rules:
          1. Fields with displayOrder are sorted before those without displayOrder
          2. Fields with conflicting displayOrder are sorted alphabetically by key
          3. Fields without displayOrder are sorted alphabetically by key
        */
        this.signUpConfig.signUpFields.sort((a, b) => {
          if (a.displayOrder && b.displayOrder) {
            if (a.displayOrder < b.displayOrder) {
              return -1;
            } else if (a.displayOrder > b.displayOrder) {
              return 1;
            } else {
              if (a.key < b.key) {
                return -1;
              } else {
                return 1;
              }
            }
          } else if (!a.displayOrder && b.displayOrder) {
            return -1;
          } else if (a.displayOrder && !b.displayOrder) {
            return 1;
          } else if (!a.displayOrder && !b.displayOrder) {
            if (a.key < b.key) {
              return 1;
            } else {
              return -1;
            }
          }
        });
      }

      return Object.assign(defaults, this.signUpConfig || {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  watch: {
    phone(number) {
      if (number.toString().length === 0) {
        this.phoneError = "Required";
        this.phoneRequirements = false;
      } else if (this.country === "1" && number.toString().length < 10) {
        this.phoneError = "Phone is invalid";
        this.phoneRequirements = false;
      } else if (this.country.concat(number.toString()).length < 8) {
        this.phoneError = "Phone is invalid";
        this.phoneRequirements = false;
      } else {
        this.phoneRequirements = true;
      }
    },
    country() {
      this.phone = "";
    }
  },
  methods: {
    async getIp() {
      try {
        let { data } = await axios.get("https://icanhazip.com")
        this.userIp = data.replace(/\n/g, '')
        this.userAgent = window.navigator.userAgent
      } catch (error) {

      }
    },
    printMe() {
      if (this.step === 1) {
        this.htmlToPaper("consent");
      } else {
        this.htmlToPaper("print");
      }
    },
    getProduct() {
      this.extraInfo.accNum = "";
      if (
        this.extraInfo.product === "banking" ||
        this.extraInfo.product === "wealth" ||
        this.extraInfo.product === "mortgage"
      ) {
        this.productLabel = "Account Number";
        this.productMask = "###############";
      } else if (this.extraInfo.product === "retirement") {
        this.productLabel = "Hire Month and Year (MM/YYYY)";
        this.productMask = "##/####";
      } else if (this.extraInfo.product === "card") {
        this.productLabel = "Last 6 Digits of Debit Card";
        this.productMask = "######";
      } else if (this.extraInfo.product === "retirementByPlan") {
        this.productLabel = "Retirement Plan Number";
        this.productMask = "";
      } else if (this.extraInfo.product === "healthDebit") {
        this.productLabel = "Last 4 Digits of Debit Card";
        this.productMask = "####";
      }
    },
    async formatAtts(atts) {
      return Object.entries(atts).map(([key, value]) => {
        return {
          Name: key,
          Value: value
        };
      });
    },
    async getProductNumber() {
      if (
        this.extraInfo.product === "banking" ||
        this.extraInfo.product === "card" ||
        this.extraInfo.product === "retirementByPlan" ||
        this.extraInfo.product === "mortgage" ||
        this.extraInfo.product === "wealth" ||
        this.extraInfo.product === "healthDebit"
      ) {
        return this.extraInfo.accNum;
      } else {
        return `${this.extraInfo.accNum.slice(
          0,
          2
        )}/${this.extraInfo.accNum.slice(2)}`;
      }
    },
    async sendDetails() {
      // this.error = "";
      if (this.extraInfo.product === "retirement") {
        var month = this.extraInfo["accNum"].slice(0, 2);
        var year = this.extraInfo["accNum"].slice(2);
      } else if (this.extraInfo.product === "card") {
        var digits = this.extraInfo["accNum"];
      }

      let newData = {
        accountNumber:
          this.extraInfo.product === "banking" ? this.extraInfo.accNum : "",
        ssn: this.extraInfo.ssn,
        accountType: this.extraInfo.product,
        hireMonth: month ? month : "",
        hireYear: year ? year : "",
        lastSixDigitsCard: digits ? digits : ""
      };

      return this.formatAtts(newData);

      // if (data.a360id && data.cif) {
      //   this.addUserProps(data);
      // } else {
      //   this.error = "User not found. Please check your information.";
      // }
    },
    comparePassword() {
      return false;
      if (
        this.options.signUpFields[2].value ===
        this.options.signUpFields[6].value
      )
        return true;
      else return false;
    },
    getAnswer(val) {
      if (val) {
        if (this.step === 2) {
          this.$store.commit("user/increaseStep");
          this.userResponse = true;
          this.dialog = false;
          this.signUp();
        } else {
          this.$store.commit("user/increaseStep");
        }
      } else {
        this.dialog = false;
      }
    },
    preSignUp() {
      if (!this.$refs.form.validate()) {
        if (!this.phone.length) {
          this.phoneError = "Required"
          this.phoneRequirements = false
        }
        return;
      } 
      this.signUp();
      // if (!this.userResponse) this.dialog = true;
      // else this.signUp();
    },
    async signUp() {
      this.error = "";
      if (this.terms && !this.userResponse) {
        this.dialog = true;
        return;
      }
      this.buttonLoad = true
      let details = await this.getProductNumber();
      let user = {
        attributes: {}
      };

      // puts field data into 'Auth.signUp' parameter structure
      this.options.signUpFields.forEach(e => {
        if (e.key === "username") {
          user.username = e.value.toLowerCase();
        } else if (e.key === "password2") {
          return;
        } else if (e.key === "password") {
          user.password = e.value;
        } else if (e.key === "email") {
          user.attributes.email = e.value.toLowerCase().trim();
        } else if (e.key === "phone_number" && e.value) {
          user.attributes.phone_number = `+${this.country}${e.value}`;
        } else {
          const newKey = `${this.needPrefix(e.key) ? "custom:" : ""}${e.key}`;
          user.attributes[newKey] = e.value;
        }
      });

      //Capitalize first and last names
      let firstName = this.extraInfo.firstName.toLowerCase().trim();
      let lastName = this.extraInfo.lastName.toLowerCase().trim();

      //set user atts
      user.attributes["custom:userStatus"] = "true";
      user.attributes["name"] = this.extraInfo.ssn;
      user.attributes["custom:product"] = this.extraInfo.product;
      user.attributes["custom:productNumber"] = details;
      user.attributes["given_name"] =
        firstName.charAt(0).toUpperCase() + firstName.slice(1);
      user.attributes["family_name"] =
        lastName.charAt(0).toUpperCase() + lastName.slice(1);
      user.attributes["custom:dateofbirth"] = this.extraInfo.dob;
      user.attributes.phone_number = `+${this.country}${this.phone}`;
      user.attributes["custom:countryCode"] = this.country;
      user.attributes["custom:userFlags"] =
        '{"isAdmin":false,"isAlerus":false,"isFCMM":false,"isICapital":false,"isKeating":false,"isMERS":false,"isEnvestnet":false,"OCEAccess":false,"CFUAccess":false,"partAccess":false}';
      if (this.mersBranded) {
        user.attributes["custom:MERS"] = "true";
        user.attributes["custom:userFlags"] =
          '{"isAdmin":false,"isAlerus":false,"isFCMM":false,"isICapital":false,"isKeating":false,"isMERS":true,"isEnvestnet":false,"OCEAccess":false,"CFUAccess":false,"partAccess":false}';
      }
      // check for system query param
      if (this.$route.query.hasOwnProperty("system")) {
        let userFlags = JSON.parse(user.attributes["custom:userFlags"])
        userFlags.system = this.$route.query.system
        user.attributes["custom:userFlags"] = JSON.stringify(userFlags)
      }
      //set validation data
      // user.validationData = details;

      // Add terms after accepted
      if (this.terms && this.userResponse) {
        user.attributes["custom:agreedterms"] = new Date().toISOString();
      }

      // Add clientMetadata object
      user.clientMetadata = {}
      // Add user ip for failures
      if (this.userIp) {
        user.clientMetadata.ip = this.userIp
      }
      // Add user agent
      if (this.userAgent) {
        user.clientMetadata.userAgent = this.userAgent
        let { browser, os } = parser(this.userAgent)
        user.clientMetadata.browserDetails = `${browser.name}, ${os.name}`
      }

      delete user.attributes.birthdate

      await this.$Amplify.Auth.signUp(user)
        .then(async data => {
          AmplifyEventBus.$emit("localUser", data.user);
          if (data.userConfirmed === false) {
            return AmplifyEventBus.$emit("authState", "confirmSignUp");
          } else {
            this.signUpSuccess = true;
          }
        })
        .catch(e => {
          if (
            e.message === "PreSignUp failed with error please accept terms."
          ) {
            this.dialog = true;
            this.terms = true;
          }
          else {
            this.setError(e);
          }
        });
        this.buttonLoad = false
    },
    validate: function() {
      let invalids = [];
      this.options.signUpFields.map(el => {
        if (el.required && !el.value) {
          invalids.push(el.label);
          Vue.set(el, "invalid", true);
        }
        return el;
      });
      if (invalids.length > 0) {
        this.setError(
          `The following fields must be completed: ${invalids.join(", ")}`
        );
      }
      return invalids.length < 1;
    },
    signIn: function() {
      this.$store.commit("user/setState", "signedOut");
      this.$router.push("/");
      // AmplifyEventBus.$emit("authState", "signedOut");
    },
    clear(field) {
      if (field && field.invalid && field.value) {
        Vue.set(field, "invalid", false);
      }
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      // this.logger.error(this.error);
    },

    // determines whether or not key needs to be prepended with 'custom:' for Cognito User Pool custom attributes.
    needPrefix: function(key) {
      const field = this.options.signUpFields.find(e => e.key === key);
      if (key.indexOf("custom:") !== 0) {
        return field.custom;
      } else if (key.indexOf("custom:") === 0 && field.custom === false) {
        this.logger.warn(
          "Custom prefix prepended to key but custom field flag is set to false"
        );
      }
      return null;
    }
  }
};
</script>

<style lang="scss">
.sign-up {
  h4 {
    font-weight: initial;
    color: #0C2B4A;
    font-size: 1.05rem;
  }
  .v-input__slot {
    border-radius: 0 !important;
  }
}
.reg-fields {
  .flex:nth-child(n + 5) {
    display: none;
  }
}
.country-list {
  .v-select__selections {
    input {
      display: none;
    }
  }
}
.su-fields {
  .Form__formField___2DWhT:nth-child(n + 7) {
    display: none;
  }
  .v-input {
    .v-input__slot {
      border: 1px solid lightgray !important;
    }
    .v-select__selections {
      padding-top: 0 !important;
    }
    border: none;
    .v-text-field__slot {
      input {
        margin-top: 10px;
      }
    }
  }
}
.full-phone {
  margin-bottom: 8px;
  .v-input__slot {
    margin-bottom: 0 !important;
  }
}
.phone-container {
  .v-text-field__details {
    padding: 0 12px;
    margin-bottom: 8px !important;
  }
}
.v-dialog {
  .v-btn__content {
    color: #fff;
    text-transform: initial;
    opacity: 0.8;
  }
}
@media (max-width: 768px) {
  .Form__formField___2DWhT {
    width: 100% !important;
    margin-bottom: 0;
  }
  .v-input__slot {
    margin-bottom: 5px !important;
  }
  .v-text-field__details {
    padding: 0 !important;
    margin-bottom: 0 !important;
  }
}
.login-form input {
  border: 1px solid lightgray;
}
</style>
<style lang="scss" scoped>
  .mers {
    .mers-text {
      margin: 0 auto 1rem;
      font-size: 0.9rem;
      display: inline-block;
      width: 100%;
    }
    .mers-auth {
      display: flex;
      flex-wrap: wrap;
      span {
        width: 100%;
        text-align: center;
      }
      button {
        background-color: #fff !important;
        color: #33715a;
        border: 1px solid;
        width: initial;
        font-size: 1rem;
        min-width: 176px;
      }
      .dark-btn {
        background-color: #33715a !important;
        color: #fff;
        border: none;
      }
      p {
        font-size: .9rem;
        margin: 1.25rem auto;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      p:before,
      p:after {
        content: '';
        border-top: 1px solid;
        margin: 0 20px 0 0;
        flex: 1 0 20px;
      }
      p:after {
        margin: 0 0 0 20px;
      }
    }
  }
</style>